// RostouciPole — textarea, která roste s textem (21.9.2026, feedback #118).
// Na začátku má `minRows` řádků, s dalším textem se sama prodlouží, takže je
// celý text vidět bez posouvání uvnitř pole. Ostatní props jdou do <textarea>.
import React, { useLayoutEffect, useRef } from "react";

export default function RostouciPole({ value, minRows = 6, className = "", style, ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      value={value}
      rows={minRows}
      className={`resize-none overflow-hidden ${className}`}
      style={style}
      {...rest}
    />
  );
}
